import OptimizedImage from "@/components/OptimizedImage";
import Marquee from "../../utils/Marquee";
import React from "react";
import { useGalleryImagesForPreview } from "@/api/hooks/useGalleryImagesForPreview";

const GalleryPlaceholder = ({ className }: { className?: string }) => (
  <div
    className={`bg-[#2C2C2E] flex items-center justify-center rounded-lg ${className}`}
    aria-hidden
  >
    <div className="w-12 h-12 rounded-full border-2 border-[#8E8E93] border-dashed opacity-50" />
  </div>
);

const ArtistEliteGallery = () => {
  const { slots } = useGalleryImagesForPreview("elite");
  const firstRowSlots = slots.slice(0, 6);
  const secondRowSlots = slots.slice(6, 12);

  const renderSlot = (
    slot: { type: "image"; id: number; url: string } | { type: "placeholder"; index: number },
    index: number,
    row: "first" | "second"
  ) => {
    const widthClass = row === "first" ? (index % 2 === 0 ? "w-[500px]" : "w-[300px]") : index % 3 === 0 ? "w-[500px]" : "w-[300px]";
    return (
      <div
        key={slot.type === "image" ? slot.id : `ph-${slot.index}`}
        className={`relative pointer-events-none max-md:h-[250px] ${widthClass} h-[400px] mx-4 overflow-hidden rounded-lg`}
      >
        {slot.type === "image" ? (
          <OptimizedImage
            src={slot.url}
            alt={`Gallery image ${index + 1}`}
            className="object-cover object-top rounded-lg"
            fill
            sizes="(max-width: 768px) 100vw, 25vw"
          />
        ) : (
          <GalleryPlaceholder className="w-full h-full" />
        )}
      </div>
    );
  };

  return (
    <div className="space-y-8 my-40 p-4 w-screen">
      <Marquee direction="left" speed={50} pauseOnHover className="h-[400px] max-md:h-[250px]">
        {firstRowSlots.map((slot, index) => renderSlot(slot, index, "first"))}
      </Marquee>
      <Marquee direction="right" speed={40} pauseOnHover className="h-[400px] max-md:h-[250px]">
        {secondRowSlots.map((slot, index) => renderSlot(slot, index + 6, "second"))}
      </Marquee>
    </div>
  );
};

export default ArtistEliteGallery;
